import React, { PureComponent, createRef } from 'react'
import { uniqBy } from 'lodash'
import {
  getSonePersonalDetails,
  getStudentProgress,
  getStudyPeriodsCodesDescription,
  searchValidUnits,
  updateEnrolment,
  getAttendanceModeCodesDetails,
  getAttendanceModeDescription } from '../../services/vu' 
import { AddUnit } from '../tags/Unit'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import qs from 'qs'
import { uniq } from 'lodash'
import { getCourseId } from '../../helpers/course'
import {
  willDoubleUpUnits,
  willOverlapUnits,
  getDualInsanceBlockModelCalendarTypes,
  getCourseStudentStudyPackageNumber,
  getAttributeCourseStaticInfo,
  alreadyEnrolledUnit,
  willExceed48CreditPoints,
  getCalendarTypeName
} from '../../helpers/enrolment'
import Loading from '../tags/Loading'
import ErrorModal from '../tags/Modals/ErrorModal'
import UnitModal from '../tags/Modals/UnitModal'
import DrupalModal from '../tags/Modals/DrupalModal'
import EnrolmentGuide from '../tags/EnrolmentGuide'
import Location from '../../enums/Location'
import { differenceInSeconds } from 'date-fns'
import { getLastPageAccessTime } from '../../helpers/gtm'
import { flatMap } from 'lodash'
import { getConfiguration } from '../../helpers/configuration'
import { processUnitAddErrors } from '../../helpers/errors'
import BlockType from '../../enums/BlockType'
import AllSettled from '../../enums/AllSettled'
import { Info, KeyboardArrowLeft, Search, Link } from '@mui/icons-material'
import { Input, List, ListItem, ListItemText, Menu, MenuItem, Popover } from '@mui/material'

class UnitSearch extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      // Reference data that we only need to load once
      studentId: '',
      enrolledUnits: this.props.location.state.enrolledUnits,
      currentEnrolment: this.props.location.state.currentEnrolment,
      cohorts: [],
      studentCalendars: [],
      locations: [],
      studyPeriod: this.props.location.state.addModalStudyPeriod,
      academicYear: parseInt(this.props.location.state.addModalYear),

      units: {},

      showModal: false,
      modalUnit: '',

      unitCode: '',
      unitTitle: '',

      loading: this.props.location.state.loadSearchUnits,
      searching: false,
      adding: false,

      hasBlockStatus: false,

      successfulRedirect: false,

      forcedLocation: false,
      defaultLocation: getAttributeCourseStaticInfo('locationCode'),

      loadSearchUnits: this.props.location.state.loadSearchUnits,
      isLoadingProgress: true,
      progress: null,
      teachingPeriod: '',
      canAddBeyondFirstYear: false,
      advanceStandingCreditRemaining: 0,
      strictPatternStudent: 'false',
      noresults: false,

      studyPackages: [],
      loadingEnrolmentGuide: false,
      reloadEnrolmentGuide: false,
      searchText: '',
      openEnrolmentErrorModel: false,
      enrolmentErrors: [],
      studyPeriods: [],
      attendanceModeList: [],
      inputSearchRef: null,
      open: true
    }
  }

  componentDidMount() {
    const nonBfySearch = this.props.location.state.nonBfySearch || false

    if (nonBfySearch) {
      this.removeBFYSearchFromCache()
    }
    this.loadBFYSearchStatesIntoCache()
    this.loadCacheIntoState()

    Promise.allSettled([getSonePersonalDetails(), getStudentProgress(getCourseId()), getStudyPeriodsCodesDescription(), getAttendanceModeCodesDetails()])
      .then(([personalDetails, studentProgress, studyPeriods, attendanceModeList]) => {
        let newState = {
          isLoadingProgress: false
        }

        if (personalDetails.status === AllSettled.FULFILLED) {
          newState = {
            ...newState,
            studentId: personalDetails.value.studentId,  
          }
        }

        if (studentProgress.status === AllSettled.FULFILLED) {
          newState = {
            ...newState,
            progress: studentProgress.value
          }
        }

        if (studyPeriods.status === AllSettled.FULFILLED) {
          newState = {
            ...newState,
            studyPeriods: studyPeriods.value.referenceCodes,
          }
        }

        if (attendanceModeList.status === AllSettled.FULFILLED) {
          newState = {
            ...newState,
            attendanceModeList : attendanceModeList.value.referenceCodes
          }
        }

        this.setState({
          ...newState
        })
      })

    window.addEventListener('beforeunload', this.displayUnconfirmedUnitsWarning)
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.displayUnconfirmedUnitsWarning)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isLoadingProgress !== this.state.isLoadingProgress && !this.state.isLoadingProgress) {
      this.trackPageView()
    }
  }
  removeBFYSearchFromCache = () => {
    sessionStorage.setItem('TEACHING_PERIOD_BFY_SEARCH', '')
    sessionStorage.setItem('CAN_ADD_BFY', false)
    sessionStorage.setItem('BFY_ADVANCE_STANDING_REM', 0)
    sessionStorage.setItem('STRICT_PATTERN_STUDENT', 'false')
    sessionStorage.setItem('ADD_MODAL_YEAR', '')
    sessionStorage.setItem('LOAD_SEARCH_UNITS', '')
  }
  loadBFYSearchStatesIntoCache = () => {
    if (this.props.location.state) {
      sessionStorage.setItem('TEACHING_PERIOD_BFY_SEARCH', this.props.location.state.teachingPeriod)
      sessionStorage.setItem('CAN_ADD_BFY', this.props.location.state.canAddBeyondFirstYear)
      sessionStorage.setItem('BFY_ADVANCE_STANDING_REM', this.props.location.state.advanceStandingCreditRemaining)
      sessionStorage.setItem('STRICT_PATTERN_STUDENT', this.props.location.state.strictPattern)
      sessionStorage.setItem('ADD_MODAL_YEAR', this.props.location.state.addModalYear)
      sessionStorage.setItem('LOAD_SEARCH_UNITS', this.props.location.state.loadSearchUnits)
    }
  }
  loadCacheIntoState = () => {
    let teachingPeriodBFY = sessionStorage.getItem('TEACHING_PERIOD_BFY_SEARCH')
    let canAddBFY = sessionStorage.getItem('CAN_ADD_BFY')
    let bfyAdvanceStandingRemaining = sessionStorage.getItem('BFY_ADVANCE_STANDING_REM')
    let strictPatternStudent = sessionStorage.getItem('STRICT_PATTERN_STUDENT')
    let addModalYear = sessionStorage.getItem('ADD_MODAL_YEAR')
    let loadSearchUnits = sessionStorage.getItem('LOAD_SEARCH_UNITS')

    this.setState({
      teachingPeriod: teachingPeriodBFY != null ? teachingPeriodBFY : '',
      canAddBeyondFirstYear: canAddBFY != null ? canAddBFY : 'false',
      advanceStandingCreditRemaining: bfyAdvanceStandingRemaining != null ? bfyAdvanceStandingRemaining : 0,
      strictPatternStudent: strictPatternStudent != null ? strictPatternStudent : 'false',
      addModalYear: addModalYear != null ? addModalYear : '',
      loadSearchUnits: loadSearchUnits !== null ? loadSearchUnits : false
    })
  }

  getProcessId = () => (this.state.progress && this.state.progress.id ? this.state.progress.id : undefined)

  trackPageView = () => {
    const lastPageAccessTime = getLastPageAccessTime()
    const pageAccessTime = new Date()

    window.dataLayer.push({
      event: 'custom.form.step.view',
      group: 'Enrol',
      processId: this.getProcessId(),
      step: {
        sequence: 4,
        label: 'Enrol in your units',
        variation: undefined,
        sub: {
          sequence: 1,
          label: 'Search Units',
          variation: undefined
        }
      },
      info: {
        time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
      },
      data: {
        value: undefined,
        courseId: getCourseId()
      }
    })

    sessionStorage.setItem('LAST_PAGE_ACCESS_TIME', JSON.stringify(pageAccessTime))
  }

  loadPrefillStatesFromCache = () => {
    let prefillAttemptSuccessful = sessionStorage.getItem('prefillAttemptSuccessful')
    let prefillPatternsFull = sessionStorage.getItem('prefillPatternsFull', true)
    let prefillAdvancedStanding = sessionStorage.getItem('prefillAdvancedStanding')
    let prefillNoPatterns = sessionStorage.getItem('prefillNoPatterns')
    let prefillPathwayStudent = sessionStorage.getItem('prefillPathwayStudent')

    this.setState({
      prefillAttemptSuccessful: prefillAttemptSuccessful != null ? prefillAttemptSuccessful : false,
      prefillPatternsFull: prefillPatternsFull != null ? prefillPatternsFull : false,
      prefillAdvancedStanding: prefillAdvancedStanding ? prefillAdvancedStanding : false,
      prefillNoPatterns: prefillNoPatterns != null ? prefillNoPatterns : false,
      prefillPathwayStudent: prefillPathwayStudent ? prefillPathwayStudent : false
    })
  }

  displayUnconfirmedUnitsWarning = event => {
    const hasUnconfirmedUnits = this.state.enrolledUnits.unitSet.some(unit => {
      return unit.unit.attemptStatus === 'UNCONFIRM'
    })

    if (hasUnconfirmedUnits) {
      event.returnValue = this.getNavigateAwayText()
      return this.getNavigateAwayText()
    }
  }

  /**
   * Dispatch error to the screen.
   * @param {*} errorText error message.
   */
    dispatchEnrolmentErrorModel = (enrolmentErrors = []) => {
      this.setState({
        openEnrolmentErrorModel: true,
        enrolmentErrors: enrolmentErrors
      })
      // alert(errorText)
      // this.handleCloseSuggestionModal()
    }

    /**
   * Handle closing of the suggestion modal.
   */
    handleCloseEnrolmentErrorModal = (enrolmentUpdating = false) => {
      this.setState({
        openEnrolmentErrorModel: false
      })
    }

  getNavigateAwayText = () => {
    return 'You have unconfirmed units in your enrolment. Please return to the previous page and confirm your enrolment before exiting.'
  }

  initialiseSearch = () => {
    if (this.state.unitTitle || this.state.unitCode) {
      this.getQuery()
        .then((units = []) => {
          let unitsToDisplay = units

          unitsToDisplay = unitsToDisplay.reduce((accumulator, currentUnit) => {
            accumulator[currentUnit.unitCode] = accumulator[currentUnit.unitCode] || []
            accumulator[currentUnit.unitCode].push(currentUnit)
            return accumulator
          }, Object.create(null))

          this.trackSearchCompletion(unitsToDisplay)

          this.setState({
            units: unitsToDisplay,
            noresults: false,
            searching: false
          })
        })
        .catch(error => {
          this.setState({
            noresults: true,
            searching: false
          })
        })
    } else {
      this.setState({
        searching: false
      })
    }
  }

  resetSearch = search => {
    this.setState({
      units: []
    })
  }

  /**
   * Hide units that the student has already enrolled in
   *
   * @param {Array} unitsToDisplay
   * @return {Array}
   */
  filterCurrentlyEnrolledUnits = (unitsToDisplay = []) => {
    const usableEnrolledUnits = Object.assign({}, this.state.enrolledUnits, {
      unitSet: this.state.enrolledUnits.unitSet.filter(unit => unit.unit.attemptStatus !== 'DISCONTIN')
    })

    const enrolledUnitCodes = usableEnrolledUnits.unitSet.map(unit => unit.unit.unitCd)

    return unitsToDisplay.filter(unit => enrolledUnitCodes.indexOf(unit.unitCode) === -1)
  }

  getEnrolledUnitCodes = () => {
    if (!this.state.enrolledUnits.hasOwnProperty('unitSet')) {
      return []
    }

    return this.state.enrolledUnits.unitSet
      .map(unit => unit.unit)
      .filter(({ attemptStatus }) => {
        return attemptStatus === 'ENROLLED' || attemptStatus === 'UNCONFIRM'
      })
  }

  /**
   * If strict pattern then add is applicable for earlier academic year
   * return the clicked add academic year units only.
   *
   * @param {Array} unitsToDisplay
   * @return {Array}
   */
  filterAddingBlockYearFromUnits = (unitsToDisplay = []) => {
    return unitsToDisplay.filter(unit => unit.supAlternateCd === this.state.addModalYear)
  }

  handleSearchFieldChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  getCampusByUnitLocationCd = unitLocationCd => {
    const location = this.state.locations.find(location => location.locationCd === unitLocationCd)
    if (location) {
      return location.description
    }
    return unitLocationCd
  }

  handleSubmitSearchRequest = event => {
    event.preventDefault()
    this.setState({
      searching: true,
      units: []
    })
    this.initialiseSearch()
  }

  getCurrentSearch = search =>
    qs.parse(search, {
      ignoreQueryPrefix: true
    })

  getCurrentSearchQuery = (search, queryParam) => {
    let searchQueryObject = this.getCurrentSearch(search)

    if (searchQueryObject.hasOwnProperty(queryParam)) {
      return searchQueryObject[queryParam]
    }
    return ''
  }

  getQuery = () => {
    return searchValidUnits(getCourseStudentStudyPackageNumber(), this.state.academicYear, this.state.studyPeriod, this.state.unitCode, this.state.unitTitle)
  }

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      modalUnit: ''
    })
  }

  handleAddUnit = unitCode => event => {
    this.trackAddUnitModalOpen()

    this.setState({
      modalUnit: unitCode,
      showModal: true
    })
  }

  getUnitsByUnitCode = () => {
    return this.state.modalUnit ? this.state.units[this.state.modalUnit] : []
  }

  setEnrolmentGuideStudyPackages = studyPackages => {
    this.setState({
      studyPackages: studyPackages
    })
  }

  setEnrolmentGuideLoading = loadingEnrolmentGuide => {
    this.setState({
      loadingEnrolmentGuide: loadingEnrolmentGuide,
      reloadEnrolmentGuide: false
    })
  }

  trackSearchCompletion = unitsObj => {
    const lastPageAccessTime = getLastPageAccessTime()
    const pageAccessTime = new Date()

    const units = flatMap(Object.keys(unitsObj), unitCode => {
      return unitsObj[unitCode].map(unit => {
        return {
          id: unitCode,
          location: this.getCampusByUnitLocationCd(unit.locationCd),
          code: unit.calType
        }
      })
    })

    window.dataLayer.push({
      event: 'custom.form.step.complete',
      group: 'Enrol',
      processId: this.getProcessId(),
      step: {
        sequence: 4,
        label: 'Enrol in your units',
        variation: undefined,
        sub: {
          sequence: 1,
          label: 'Search Units',
          variation: undefined
        }
      },
      info: {
        time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
      },
      data: {
        value: undefined,
        courseId: getCourseId(),
        units: units
      }
    })
  }

  trackAddUnitModalOpen = () => {
    const lastPageAccessTime = getLastPageAccessTime()
    const pageAccessTime = new Date()

    window.dataLayer.push({
      event: 'custom.form.step.view',
      group: 'Enrol',
      processId: this.getProcessId(),
      step: {
        sequence: 4,
        label: 'Enrol in your units',
        variation: undefined,
        sub: {
          sequence: 2,
          label: 'Add & Enrol',
          variation: undefined
        }
      },
      info: {
        time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
      },
      data: {
        value: undefined,
        courseId: getCourseId()
      }
    })

    sessionStorage.setItem('LAST_PAGE_ACCESS_TIME', JSON.stringify(pageAccessTime))
  }

  getEnrolledUnits = () => {
    // VO-70: If a student has the "forced location" flag set in VU Connect,
    // filter out enrolled units with locations not associated with the
    // student's default campus location.
    //    if (this.state.forcedLocation) {
    //      return this.state.enrolledUnits.filter(
    //        unit => unit.locationCd === this.state.defaultLocation
    //      )
    //    }

    return this.state.enrolledUnits
  }

  /**
   * Get all the units with attempt students that Victoria University considers
   * to be "enrolled".
   *
   * @return {Array}
   */
  getActiveEnrolledUnits = (excludeFailed = false) => {
    return this.getEnrolledUnits().filter(unit => {
      if (excludeFailed) {
        return unit.unitStatus !== 'WD' && unit.unitStatus !== 'WDE' && unit.unitStatus !== 'FAIL' && unit.removed !== true
      } else {
        return unit.unitStatus !== 'WD' && unit.unitStatus !== 'WDE' && unit.removed !== true
      }
    })
  }

  handleConfirmAddUnit = unit => {
    if (this.state.defaultLocation !== Location.ZV && unit.unitAvailabilityLocationCode === Location.ZV) {
      const confirmed = window.confirm('This is an online unit. Are you sure you want to add this unit to your enrolment?')
      if (!confirmed) {
        return
      }
    }

    this.setState({
      adding: true
    })

    let blockCode = getAttributeCourseStaticInfo('blockCode')

    if (blockCode !== BlockType.FourWeekBlock && blockCode !== BlockType.EightWeekBlock) {
      if(willExceed48CreditPoints(this.getActiveEnrolledUnits(true), unit)) {
        this.dispatchError(`Unable to enrol. You can only enrol in 48 Credit Points for ${unit.unitAvailabilityYear} ${getCalendarTypeName(unit.unitAvailabilityStudyPeriodCode, this.state.studyPeriods)}. For assistance, please contact VUHQ`)
        return
      }
    }

    const testDoubleUp = willDoubleUpUnits(
      this.getActiveEnrolledUnits(),
      unit.unitAvailabilityStudyPeriodCode,
      unit.unitAvailabilityYear,
      getDualInsanceBlockModelCalendarTypes().indexOf(unit.unitAvailabilityStudyPeriodCode) > -1 ? 2 : 1
    )

    if (testDoubleUp) {
      let doubleUpText =
        getDualInsanceBlockModelCalendarTypes().indexOf(unit.unitAvailabilityYear) > -1
          ? 'Maximum two units can be enrolled in a 8 Weeks Teaching Block. ' + 'You will need remove the existing unit from the block first before attempting to enrol into this unit.'
          : 'Unable to enrol. You have already enrolled in a unit for ' + unit.unitAvailabilityYear + ' in ' + getCalendarTypeName(unit.unitAvailabilityStudyPeriodCode, this.state.studyPeriods) + '. For assistance, please contact VUHQ'

      this.dispatchError(doubleUpText)
      return
    }

    if (alreadyEnrolledUnit(this.getActiveEnrolledUnits(true), unit)) {
      this.dispatchError('Unable to enrol. You are already enrolled in this unit. For assistance, please contact VUHQ')
      return
    }

    const testOverlapUnits = willOverlapUnits(unit, this.getActiveEnrolledUnits())

    const twoBlocks = unit.unitCreditPoints / 12 === 2
    let blockText = !twoBlocks ? `${unit.unitCreditPoints / 12} blocks` : 'block'
    if (testOverlapUnits) {
      this.dispatchError(
        `${unit.unitCode} is ${unit.unitCreditPoints} credit points and requires enrolment across ${unit.unitCreditPoints /
          12} consecutive blocks. Please remove any units currently enrolled in the following ${blockText} and try again.`
      )
      return
    }

    updateEnrolment(this.getEnrolmentPayload(unit))
      .then((responses = []) => {
        this.trackAddCompletion(unit)

        this.setState({
          successfulRedirect: true
        })
      })
      .catch(error => {
        let errorMessage = 'Unable to add unit to your enrolment. For assistance, please contact VUHQ.'
        // if (responses.length > 0) {
        //   const response = responses[0]
        //   errorMessage = response.unitResponse.msgText
        // }

        this.dispatchEnrolmentErrorModel(error.response.data.unitErrors)
        //this.dispatchError(errorMessage)
        //
        // this.removeUnit(unit).then(
        //   () => {
        //     this.dispatchError(errorMessage)
        //   },
        //   () => {
        //     this.dispatchError(errorMessage)
        //   }
        // )
      })
  }

  trackAddCompletion = ({ calendarType, unitCd, locationCd }) => {
    const lastPageAccessTime = getLastPageAccessTime()
    const pageAccessTime = new Date()

    window.dataLayer.push({
      event: 'custom.form.step.complete',
      group: 'Enrol',
      processId: this.getProcessId(),
      step: {
        sequence: 4,
        label: 'Enrol in your units',
        variation: undefined,
        sub: {
          sequence: 1,
          label: 'Add & Enrol',
          variation: undefined
        },
        info: {
          time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
        },
        data: {
          value: undefined,
          courseId: getCourseId(),
          units: [
            {
              id: unitCd,
              location: this.getCampusByUnitLocationCd(locationCd),
              code: calendarType
            }
          ]
        }
      }
    })
  }

  getPreviouslyEnrolledUnit = unit => {
    return this.state.enrolledUnits.find(enrolledUnit => {
      return (
        (enrolledUnit.unitStatus === 'WD' || enrolledUnit.unitStatus === 'WDE') &&
        enrolledUnit.unitCode === unit.unitCode &&
        enrolledUnit.unitAvailabilityStudyPeriodCode === unit.unitAvailabilityStudyPeriodCode &&
        enrolledUnit.unitAvailabilityYear === unit.unitAvailabilityYear
      )
    })
  }

  getUnconfirmedUnit = unit => {
    return this.state.enrolledUnits.find(enrolledUnit => {
      return (
        enrolledUnit.unit.attemptStatus === 'UNCONFIRM' &&
        enrolledUnit.unit.unitCd === unit.unitCode &&
        enrolledUnit.unit.calendarType === unit.calType &&
        enrolledUnit.unit.supAlternateCd === unit.supAlternateCd
      )
    })
  }

  getEnrolmentPayload = unit => ({
    courseCode: getAttributeCourseStaticInfo('courseCode'),
    courseVersion: getAttributeCourseStaticInfo('versionNumber'),
    courseAttemptNumber: getAttributeCourseStaticInfo('attemptNumber'),
    academicYear: this.state.academicYear,
    parentSspNo: getCourseStudentStudyPackageNumber(),
    studentUnits: [unit]
  })

  // removeUnit = payload =>
  //   updateEnrolment(
  //     this.getEnrolmentPayload(
  //       Object.assign({}, payload, {
  //         action: 'DELETE'
  //       })
  //     )
  //   )

  dispatchError = errorText => {
    alert(errorText)
    this.setState({
      adding: false
    })
  }

  handleInfoCloseModal = () => {
    this.setState({
      showInfoModal: false
    })
  }

  getSortedUnitCodes = () => {
    return Object.keys(this.state.units).sort()
  }

  hasRequisite = (units = []) => {
    return units.some(unit => unit.unitRequisiteFlag)
  }

  getAllCoursePatterns = () => {
    return this.state.coursePatterns.bau.core.concat(this.state.coursePatterns.nonCore)
  }

  handleOnFocus = event => {
    this.setState({
      open:true,
      inputSearchRef: event.currentTarget
    })
  }

  handleRequestClose = (event) => {
    this.setState({
      open: false,
      inputSearchRef: null
    })
  }

  handleSelectionOfStudyPackage = (event, studyPackage) => {
    event.stopPropagation();
    this.setState({
      unitCode: studyPackage.unitCode,
      open: false
    })
  }

  handleGetStudyPackages = () => {
    var studyPackages = this.state.studyPackages

    if (this.state.studyPeriod) {
      studyPackages = studyPackages.filter(sp => sp.unitAvailabilityStudyPeriodCode === this.state.studyPeriod)
    }

    return studyPackages
  }

  render() {
    const popoverId = this.state.open ? 'unitSearchUnitCodeSearchField' : undefined;

    if (this.state.successfulRedirect) {
      return (
        <Switch>
          <Route
            path={getConfiguration('baseUrl') + '/manage/units/enrolments/add'}
            render={() => <Redirect to={getConfiguration('baseUrl') + '/manage/units/' + this.state.academicYear} />}
          />
          <Route render={() => <Redirect to={getConfiguration('baseUrl') + '/units'} />} />
        </Switch>
      )
    }

    return !this.state.isLoadingProgress && (
      <div className="page page_fullWidth page__unitsAdd">
        <div className="nav-back">
          <Switch>
            <Route
              path={getConfiguration('baseUrl') + '/manage/units/enrolments/add'}
              render={() => (
                <button className="btn" onClick={() => this.props.history.push(getConfiguration('baseUrl') + '/manage/units/' + this.state.academicYear)}>
                  <KeyboardArrowLeft className="btn-point-events" /> <span>Back</span>
                </button>
              )}
            />
            <Route
              render={() => (
                <button className="btn" onClick={() => this.props.history.push(getConfiguration('baseUrl') + '/units')}>
                  <KeyboardArrowLeft className="btn-point-events" /> <span>Back</span>
                </button>
              )}
            />
          </Switch>
        </div>

        <div className="container-narrow">
          <h1>Search Units</h1>
        </div>
        <div className="info-link" style={{marginBottom: 0}}>
          <p className="center">
            <Info className="btn-point-events" />{' '}
            <button className="btn-link find-course-plan-btn" onClick={() => this.setState({ showInfoModal: true })}>
              Not sure what units to choose?
            </button>
          </p>
        </div>
        <div className="search-bar">
          <div className="container-narrow">
            <form className="search-group" onSubmit={this.handleSubmitSearchRequest}>
              <Input
                className="search-field search-field--unit-code"
                id='unitSearchUnitCodeSearchField'
                name="unitCode"
                placeholder="Unit code"
                onFocus={this.handleOnFocus}
                onChange={this.handleSearchFieldChange}
                autoFocus={true}
                value={this.state.unitCode}
                inputRef={input => this.tf = input}
                autoComplete={'off'}
              />
              { this.state.inputSearchRef && (
                <Popover
                  open={this.state.open}
                  anchorEl={this.state.inputSearchRef}
                  anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                  }}
                  onClose={this.handleRequestClose}
                  disableAutoFocus
                >
                  <List>
                    {this.state.studyPackages &&
                      uniqBy(this.handleGetStudyPackages(), 'unitCode')
                        .filter(studyPackage => !this.state.unitCode || !studyPackage.unitCode || studyPackage.unitCode.toUpperCase().indexOf(this.state.unitCode.toUpperCase()) !== -1)
                        .map(studyPackage => (
                          <ListItem 
                            key={studyPackage.unitCode} 
                            onClick={event => this.handleSelectionOfStudyPackage(event, studyPackage)} 
                          >
                            <ListItemText primary={studyPackage.unitCode} />
                          </ListItem>
                        ))}
                  </List>
                </Popover>
              )}
             
              <Input 
                className="search-field search-field--unit-name" 
                name="unitTitle" placeholder="Unit name" 
                onChange={this.handleSearchFieldChange} 
                value={this.state.unitTitle} />
              <button type='submit' className="search-btn search-units-btn">
                <Search className="btn-point-events" />
              </button>
            </form>
          </div>
        </div>

        <div className="container-results container-narrow">
          {Object.keys(this.state.units) && Object.keys(this.state.units).length > 0 ? (
            <div className="row">
              <div className="col-xs-12">
                <div className="legend-container">
                  <div className="legend-item">
                    <span className="key key-available" /> <span className="key-txt">Available</span>
                  </div>
                  {/*<div className="legend-item"><span className="key key-prerequisite" /> <span className="key-txt">Prerequisite unit required</span><span className="tooltip"><ActionHelp/></span></div>*/}
                  <div className="legend-item">
                    <span className="icon-prerequisite">
                      <Link />
                    </span>{' '}
                    <span className="key-txt">Requisite associated</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>
              {this.state.loading || (this.state.loadingEnrolmentGuide && <Loading message="Loading..." />)}
              {this.state.searching && <Loading message="Searching..." />}
              {!this.state.loading && !this.state.loadingEnrolmentGuide && !this.state.searching && !this.state.noresults ? (
                <div className="empty-state-container">
                  <div className="empty-state-container__search">
                    <div className="icon" />
                    <h2>Search</h2>
                    <p>
                      Search by <strong>unit code</strong> or <strong>unit name</strong> in the bar above.
                    </p>
                    <div className="sidenote">
                      <div className="sidenote__content">
                        <p>
                          <strong>Not sure about your course structure?</strong> If you are having trouble deciding on which unit to choose in blocks with multiple offerings, you may like to
                          refer to the timetable to select the unit offered at the time that is most suitable to you. If you are looking for more information about your course structure and
                          units, refer to your{' '}
                          <a href="https://www.vu.edu.au/current-students/your-course/enrolment/course-delivery-plans" target="_blank" style={{textDecoration: 'underline'}}>
                            course plan
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {!this.state.loading &&
              !this.state.loadingEnrolmentGuide &&
              !this.state.searching &&
              this.state.noresults &&
              Object.keys(this.state.units) &&
              Object.keys(this.state.units).length === 0 ? (
                <div className="empty-state-container">
                  <div className="empty-state-container__no-results">
                    <div className="icon" />
                    <h2>No results</h2>
                    <p>
                      Your search returned <strong>0 results</strong>. Please try a different search.
                    </p>
                  </div>
                </div>
              ) : null}
            </div>
          )}

          <div className="row search-results">
            {this.getSortedUnitCodes().map(code => {
              const units = this.state.units[code]
              if (units.length === 0) {
                return null
              }

              const unitCode = units[0].unitCode
              const unitShortTitle = units[0].unitShortTitle
              const unitCreditPoints = units[0].unitCreditPoints
              const unitAvailabilityLocationDescription = units[0].unitAvailabilityLocationDescription
              const unitAvailabilityAttendanceModeDescription = getAttendanceModeDescription(this.state.attendanceModeList,units[0].unitAvailabilityAttendanceModeCode)

              const availableLocations = uniq(units.map(unit => unit.unitAvailabilityLocationCode))
              const availableAttendanceMode = uniq(units.map(unit => unit.unitAvailabilityAttendanceModeCode))

              return (
                <div className="col-xs-6 col-sm-3" key={unitCode}>
                  <AddUnit
                    code={unitCode}
                    name={unitShortTitle}
                    creditPoints={`${unitCreditPoints || 0} points`}
                    attendanceMode={availableAttendanceMode.length > 1 ? 'Multiple Delivery' : unitAvailabilityAttendanceModeDescription}
                    campus={availableLocations.length > 1 ? 'Multiple locations' : unitAvailabilityLocationDescription}
                    core={false}
                    onAdd={this.handleAddUnit(unitCode)}
                    disabled={units.every(unit => unit.unitAvailabilityMaxQuota > 0 && unit.unitAvailabilityQuotaRemaining !== null && unit.unitAvailabilityQuotaRemaining <= 0)}
                    hasRequisite={this.hasRequisite(units)}
                  />
                </div>
              )
            })}
          </div>

          <UnitModal
            handleCloseModal={this.handleCloseModal}
            handleSubmitUnit={this.handleConfirmAddUnit}
            handleError={this.dispatchError}
            isOpen={this.state.showModal}
            unitCode={this.state.modalUnit}
            loading={false}
            submitting={this.state.adding}
            units={this.getUnitsByUnitCode()}
            enrolledUnits={this.getEnrolledUnitCodes()}
            title={`Add & enrol | ${this.state.modalUnit}`}
            buttonText="Enrol in unit"
            buttonLoadText="Enrolling in unit..."
            canAddBeyondFirstYear={this.state.canAddBeyondFirstYear}
            advanceStandingCreditRemaining={this.state.advanceStandingCreditRemaining}
            academicYear={this.state.academicYear}
            studyPeriod={this.state.studyPeriod}
            dispatchError={this.dispatchError}
          />
          <DrupalModal className="modal-lg" isOpen={this.state.showInfoModal} handleCloseModal={this.handleInfoCloseModal} slug="unit-information" />
          <ErrorModal
            title="Updating enrolments failed"
            isOpen={this.state.openEnrolmentErrorModel}
            handleCloseModal={this.handleCloseEnrolmentErrorModal}
            className="modal-xl"
            >
              {processUnitAddErrors(this.state.enrolmentErrors, false, "put_courses_coursecode_enrolments_general_exception")}
          </ErrorModal>
        </div>

        <EnrolmentGuide
          //Not needed as it gets this query param search
          //  enrollingForFirstTime={this.props.enrollingForFirstTime}
          hasBlockStatus={this.state.hasBlockStatus}
          availabilityYear={this.state.academicYear}
          setEnrolmentGuideStudyPackages={this.setEnrolmentGuideStudyPackages}
          setEnrolmentGuideLoading={this.setEnrolmentGuideLoading}
          //  prefillAdvancedStanding={this.state.prefillAdvancedStanding}
          //   prefillPathwayStudent={this.state.prefillPathwayStudent}
        />
      </div>
    )
  }
}

export default withRouter(UnitSearch)
